const ROLE_CLAIM_URI =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
const NAME_CLAIM_URI =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name";

function asArray(value) {
  if (value == null || value === "") return [];
  return Array.isArray(value) ? value : [value];
}

/**
 * Admin flag comes from ClaimTypes.Role ("role" / long URI) = "Admin"|"User".
 * Do NOT use the custom "Roles" claim (app roles) — key.includes("role") matches it.
 */
export function isAdminFromTokenPayload(tokenPayload) {
  if (!tokenPayload) return false;

  const roleClaim = tokenPayload[ROLE_CLAIM_URI] || tokenPayload.role;
  return asArray(roleClaim).some(
    (r) => r && String(r).toLowerCase() === "admin"
  );
}

export function claimsFromTokenPayload(tokenPayload) {
  return asArray(tokenPayload && tokenPayload.claims);
}

/**
 * App roles live on the custom "Roles" claim.
 * Do not read "role" / ClaimTypes.Role — that value is only "Admin" or "User".
 */
export function rolesFromTokenPayload(tokenPayload) {
  if (!tokenPayload) return [];

  return asArray(tokenPayload.Roles).filter(
    (role) => role != null && String(role) !== ""
  );
}

export function rolesFromStorage(raw) {
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.filter((role) => role != null && String(role) !== "");
    }
  } catch (e) {
    // Older logins stored a comma-separated string.
  }

  return String(raw)
    .split(",")
    .map((role) => role.trim())
    .filter(Boolean);
}

export function userFromTokenPayload(tokenPayload) {
  if (!tokenPayload) return "";
  return tokenPayload[NAME_CLAIM_URI] || tokenPayload.unique_name || "";
}

export function parseJwtPayload(token) {
  if (!token) return null;
  const parts = token.replace(/^Bearer\s+/i, "").split(".");
  if (parts.length < 2) return null;
  return JSON.parse(atob(parts[1]));
}
